import getSubtest from "./getSubtest";
import checkRating from "./checkRating";
import values from 'mout/object/values'
import totalArray from "../totalArray";

export default function getStaminaRating(userAssessment) {
  
  const ratingThresholds = {
    'ReadingToEnglish': [
      {percent: 95, rating: 10},
      {percent: 90, rating: 9},
      {percent: 86, rating: 8},
      {percent: 82, rating: 7},
      {percent: 78, rating: 6},
      {percent: 75, rating: 5},
      {percent: 71, rating: 4},
      {percent: 67, rating: 3},
      {percent: 63, rating: 2},
      {percent: 57, rating: 1},
    ],
    'ScienceToMath': [
      {percent: 95, rating: 10},
      {percent: 90, rating: 9},
      {percent: 86, rating: 8},
      {percent: 82, rating: 7},
      {percent: 78, rating: 6},
      {percent: 75, rating: 5},
      {percent: 71, rating: 4},
      {percent: 67, rating: 3},
      {percent: 63, rating: 2},
      {percent: 57, rating: 1},
    ]
  }

  function getSubjectsRating(userAssessment, subjects) {
    let subs = []
    if (subjects === 'ReadingToEnglish') {
      subs = ['Reading', 'English']
    } else if (subjects === 'ScienceToMath') {
      subs = ['Science', 'Math']
    } else return null
    const subtestA = getSubtest(subs[0], userAssessment)
    const subtestB = getSubtest(subs[1], userAssessment)
    const subtestAId = subtestA.setId
    const subtestBId = subtestB.setId
    const subtestAScale = userAssessment.scoring.bySubtest[subtestAId] ? Number(userAssessment.scoring.bySubtest[subtestAId].scale) : 0
    const subtestBScale = userAssessment.scoring.bySubtest[subtestBId] ? Number(userAssessment.scoring.bySubtest[subtestBId].scale) : 0
    let score = 0
    if (subtestBScale !== 0) {
      score = subtestAScale / subtestBScale * 100
    }
    function ratingTest(r, score) {
      return score > r.percent
    }
    return checkRating(ratingThresholds, subjects, score, ratingTest)
  }

  function getStamina(userAssessment) {
    let stamina = {
      'ReadingToEnglish': getSubjectsRating(userAssessment, 'ReadingToEnglish'),
      'ScienceToMath': getSubjectsRating(userAssessment, 'ScienceToMath'),
    }
    const stars = Math.round(totalArray(values(stamina)) / 4)
    stamina.stars = stars
    return stamina
  }

  return getStamina(userAssessment)

}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getStaminaRating.js